import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
 
const notyf = new Notyf({
  duration: 2500,
  position: { x: 'right', y: 'bottom' },
  ripple: false,
  dismissible: false,
  types: [
    {
      type: 'warning',
      background: '#ffc107',
      icon: {
        className: 'bi bi-exclamation-triangle-fill',
        tagName: 'i',
        color: '#ffffff'
      }
    },
    {
      type: 'info',
      background: '#0dcaf0',
      icon: {
        className: 'bi bi-info-circle-fill',
        tagName: 'i',
        color: '#ffffff'
      }
    }
  ]
});
 
// Add custom methods
notyf.info = (message) =>
  notyf.open({
    type: 'info',
    message
  });
 
notyf.warning = (message) =>
  notyf.open({
    type: 'warning',
    message
  });
 
export default {
  install(app) {
    app.config.globalProperties.$notyf = notyf;
  }
};
 
 